import React from 'react';
import { MarketingImage } from 'components/MarketingPagesShared/MarketingImage';
import {
  SwitchQuote,
  SwitchQuoteText,
  SwitchQuoteAuthor,
  SwitchQuotePodcast,
} from '../../styles';

export function QuotesBR() {
  return (
    <>
      <SwitchQuote>
        <MarketingImage
          imagePath="switch/quotes/localized-assets/pt-BR/pod-pah"
          alt="Podpah podcast cover"
          width={342}
          height={342}
        />
        <SwitchQuoteAuthor>Igão and Mitico</SwitchQuoteAuthor>
        <SwitchQuotePodcast>Podpah</SwitchQuotePodcast>
        <SwitchQuoteText>
          “A Anchor é a principal plataforma de criação, edição e distribuição
          de podcasts do mundo, e para o Podpah é extremamente relevante
          utilizar de recursos que nos ajudam a crescer ainda mais. Para nós, é
          uma segurança estarmos com a melhor estrutura de desenvolvimento de
          podcasts, excelente forma de falar com o nosso público e saber mais
          sobre ele também”
        </SwitchQuoteText>
      </SwitchQuote>
      <SwitchQuote>
        <MarketingImage
          imagePath="switch/quotes/localized-assets/pt-BR/vaca-cast"
          alt="Vaca Cast podcast cover"
          width={342}
          height={342}
        />
        <SwitchQuoteAuthor>Evelyn Regly</SwitchQuoteAuthor>
        <SwitchQuotePodcast>VACA CAST</SwitchQuotePodcast>
        <SwitchQuoteText>
          “Quando a gente lança um podcast não imagina todo o trabalho
          envolvido! E contar com uma plataforma como a Anchor para gerenciar a
          publicação dos episódios é muito prático. Além de ser simples de usar:
          piscou e já foi distribuído em todos os streamings. Recomendo demais!”
        </SwitchQuoteText>
      </SwitchQuote>
      <SwitchQuote>
        <MarketingImage
          imagePath="switch/quotes/localized-assets/pt-BR/cha-math"
          alt="Cha Math podcast cover"
          width={342}
          height={342}
        />
        <SwitchQuoteAuthor>Londrinando</SwitchQuoteAuthor>
        <SwitchQuotePodcast>Cha Math com Rafa</SwitchQuotePodcast>
        <SwitchQuoteText>
          “A gente sempre sonhou em ter o nosso próprio podcast, mas a ideia
          sempre parecia inviável e um pouco distante. Conhecer a Anchor foi
          definitivo para nos ajudar a tirar o projeto do papel. A plataforma é
          completa para iniciantes e tem tudo que a gente precisa! Por lá,
          conseguimos editar e gravar os áudios, mesmo que com convidados a
          distância. Além disso, a ferramenta possui funções como cortes,
          efeitos de som e ainda é possível adicionar trilha sonora, tudo isso
          direto do celular! É realmente muito fácil e prático!”
        </SwitchQuoteText>
      </SwitchQuote>
    </>
  );
}
